import { render } from "./AutomationPieces.vue?vue&type=template&id=cd53c5d2&scoped=true"
import script from "./AutomationPieces.vue?vue&type=script&lang=js"
export * from "./AutomationPieces.vue?vue&type=script&lang=js"

import "./AutomationPieces.vue?vue&type=style&index=0&id=cd53c5d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd53c5d2"]])

export default __exports__